import type { ImportAuditResult } from '@repo/contracts';

import { apiFetch } from './client';

/**
 * Opens an extension audit as a room. The server reads the audit's screenshot
 * and findings itself; an audit opened before returns the same session.
 */
export const importAudit = (auditId: string) =>
  apiFetch<ImportAuditResult>('/canvas/audit-imports', {
    body: JSON.stringify({ auditId }),
    method: 'POST',
  });
